import { render, staticRenderFns } from "./NavigationSection.vue?vue&type=template&id=496bdd2a&"
import script from "./NavigationSection.vue?vue&type=script&lang=ts&"
export * from "./NavigationSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports